import SEO from "@/components/SEO";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Features from "@/components/home/Features";
import HowItWorks from "@/components/home/HowItWorks";
import Premium from "@/components/home/Premium";
import Security from "@/components/home/Security";
import Disclaimer from "@/components/home/Disclaimer";
import Faq from "@/components/home/Faq";

export default function Home() {
  return (
    <>
      <SEO
        title="Nova | Take control of your money"
        description="Plan your budget, organise debts, understand your spending and build a clearer path towards your financial goals with Nova."
        path="/"
      />
      <Hero />
      <Marquee />
      <Features />
      <HowItWorks />
      <Premium />
      <Security />
      <Disclaimer />
      <Faq />
    </>
  );
}
